var LoginCta       = require("./LoginCta"),
    SignUpCta      = require("./SignUpCta"),
    SimplePageView = require("app/AppLayout/SimplePageView"),
    kind           = require("enyo/kind");

require("./PageView.less");

module.exports = kind(/** @lends  app.UserRequiredPage.PageView.prototype */ {

    /**
     * @private
     */
    name: "app.UserRequiredPage.PageView",

    /**
     * @private
     */
    kind: SimplePageView,

    /**
     * @private
     */
    classes: "app-user-required-page-page-view",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * @private
     */
    components: [{
        classes:    "app-user-required-page-page-view__content",
        components: [{
            name:    "loginCta",
            kind:    LoginCta,
            classes: "app-user-required-page-page-view__login-cta"
        }, {
            tag:     "hr",
            classes: "app-user-required-page-page-view__separator"
        }, {
            name:    "signUpCta",
            kind:    SignUpCta,
            classes: "app-user-required-page-page-view__sign-up-cta"
        }]
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.loginCta.state"
    }, {
        from: ".state",
        to:   ".$.signUpCta.state"
    }]

});
